import numeral from 'numeral';

export function fData(number) {
  return numeral(number).format('0.0 b');
}

export function fBytesToSize(bytes) {
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  if (bytes === 0) return '0 Byte';
  const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
  return `${Math.round(bytes / 1024 ** i, 2)} ${sizes[i]}`;
}

export function addCommasToNumber(num) {
  const numStr = num.toString();

  const [integerPart, decimalPart] = numStr.split('.');

  let formattedNumber = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  if (decimalPart) {
    formattedNumber += `.${decimalPart}`;
  }

  return formattedNumber;
}

export function formatNumberWithCommas(number) {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
